module.exports = __webpack_public_path__ + "static/media/rec3.897e17b5.jpg";